import { ArrowDown, ArrowUpRight } from "lucide-react";
import { track } from "@/lib/analytics";
import appHome from "@/assets/screens/app-home.png";

export default function Hero() {
  return (
    <section className="field-hero">
      <div className="container">
        <div className="field-hero-heading">
          <div>
            <p className="field-eyebrow"><span /> Le logiciel des coachs indépendants</p>
            <h1>Gérez moins.<br /><em>Coachez plus.</em></h1>
          </div>
          <div className="field-hero-intro">
            <p>Fini les fichiers Excel éparpillés et les WhatsApp à 22&nbsp;h. CoachOS crée vos programmes en minutes et <strong>relance vos clients avant qu'ils ne disparaissent</strong>.</p>
            <div className="field-hero-actions">
            <a className="field-primary" href="#contact" onClick={() => track("demo_cta_clicked", { cta: "request_demo", location: "hero", destination: "contact" })}>Voir une démo <ArrowUpRight size={19} aria-hidden="true" /></a>
            <a className="field-demo" href="#pricing" onClick={() => track("landing_cta_clicked", { cta: "view_pricing", location: "hero", destination: "pricing" })}>Découvrir les tarifs <ArrowUpRight size={14} aria-hidden="true" /></a>
            </div>
            <p className="field-hero-assurance">Sans engagement · Mise en route en 10 min · Résiliable à tout moment</p>
          </div>
        </div>
        <div className="field-scene">
          <img className="field-photo" src="/art/coaching-session.webp" alt="Une sportive réalise sa séance avec un coach attentif à son mouvement" fetchPriority="high" width={1536} height={1024} />
          <div className="field-scene-shade" aria-hidden="true" />
          <div className="field-product">
            <span className="field-product-label">VOTRE COACHING. TOUJOURS AVEC EUX.</span>
            <a href="#apps" aria-label="Découvrir l’application client CoachOS" className="field-phone"><img src={appHome} alt="CoachOS : séance du jour et programme de la semaine" width={390} height={844} /></a>
            <span className="field-product-platform">Web · iOS · Android</span>
          </div>
          <div className="field-scene-caption"><span>PRÉSENT À CHAQUE ÉTAPE</span><p>Le déclic, c’est vous.<br />La continuité, c’est CoachOS.</p><a href="#features">Entrez sur le terrain <ArrowDown size={16} aria-hidden="true" /></a></div>
          <span className="field-photo-credit">Visuel d’illustration</span>
        </div>
      </div>
    </section>
  );
}
